import agreementPermissionActionTypes from "../actions/agreementPermissionActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const agreementPermissionReducer = reducerFactory.readReducer(
  agreementPermissionActionTypes
);
